import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { ChartAttributeName } from "utlis/utils";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { capitalize } from "lodash";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const FONT_FAMILY = "Inter";
const FONT_SIZE = 16;
const FONT_WEIGHT = 600;
const COLORS = [
  "#7F56D9",
  "#9E77ED",
  "#B692F6",
  "#D6BBFB",
  "#E9D7FE",
  "#F4EBFF",
];

const getColor = (input) => {
  if (typeof input === "number") {
    return COLORS.slice(0, input);
  }
  return COLORS[input % COLORS.length];
};

const BaseDoughnutChart = ({ labels, datasets, title, radius, cutout }) => {
  const chartConfig = useMemo(() => {
    const chartDatasets = Object.keys(datasets).map((key) => ({
      label: " Count",
      backgroundColor: getColor(labels?.length),
      data: datasets[key],
    }));

    return {
      data: {
        labels: labels.map((label) => capitalize(label)),
        datasets: chartDatasets,
      },
      options: {
        cutout: cutout || 70,
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
        plugins: {
          title: {
            display: true,
            text: title,
            align: "start",
            font: {
              family: FONT_FAMILY,
              weight: FONT_WEIGHT,
              size: FONT_SIZE,
            },
            padding: {
              top: 12,
              bottom: 24,
            },
            color: "#30301B",
          },
          legend: {
            display: true,
            position: "right",
            align: "start",
            labels: {
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
              pointStyle: "circle",
              font: {
                family: FONT_FAMILY,
                size: 12,
                weight: 400,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
          datalabels: {
            display: true,
            formatter: (value, context) => {
              const dataset = context.dataset.data;
              const total = dataset.reduce((acc, val) => acc + val, 0);
              const percentage = ((value / total) * 100).toFixed(1);
              if(percentage === "0.0") return "";
              return `${percentage}%`;
            },
            color: "#fff",
            font: {
              family: FONT_FAMILY,
              size: 12,
              weight: 400,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        radius: radius || "100%"
      },
    };
  }, [labels, datasets, title]);

  return (
    <Doughnut
      data={chartConfig.data}
      options={chartConfig.options}
      plugins={[ChartDataLabels]}
    />
  );
};

export default BaseDoughnutChart;
